import { getAPI, postAPI } from "../..";
import config from "../../../utils/config";
import {
  EXTERNAL_LOGIN_URL,
  LOGIN_URL,
  LOGOUT_URL,
  OTP_VERIFICATION_URL,
  SSO_LOGOUT_URL,
  USER_INFORMATION,
} from "../../url";

export const userLoginAPI = async (creds) => {
  let response = await postAPI(config.authUrl + LOGIN_URL, creds);
  return response;
};

export const externalLoginAPI = async (email) => {
  let response = await getAPI(config.authUrl + EXTERNAL_LOGIN_URL + email);
  return response;
};

export const verifyOtpAPI = async (email, otp) => {
  let response = await getAPI(
    config.authUrl + OTP_VERIFICATION_URL + email + "&otp=" + otp
  );
  return response;
};

export const userLogoutAPI = async () => {
  let response = await getAPI(config.authUrl + LOGOUT_URL);
  return response;
};

export const ssoLogoutAPI = async () => {
  let response = await getAPI(config.authUrl + SSO_LOGOUT_URL);
  return response;
};

export const getUserInformations = async () => {
  let response = await getAPI(config.authUrl + USER_INFORMATION);
  return response;
};
